// Registre central des articles affiliation
// Structure parallèle au blog classique, dédiée aux avis de logiciels/outils

import { affiliationMeta as clickmeeting } from '../posts/affiliation/clickmeeting-avis-videoconference.js';
import { affiliationMeta as ringover } from '../posts/affiliation/ringover-avis-telephonie.js';
import { affiliationMeta as expensya } from '../posts/affiliation/expensya-avis-note-de-frais.js';
import { affiliationMeta as jobadder } from '../posts/affiliation/jobadder-avis-ats-recrutement.js';

export const affiliationPosts = [
  clickmeeting,
  ringover,
  expensya,
  jobadder,
];

export const getAffiliationById = (id) => affiliationPosts.find(p => p.id === id);

export const getAffiliationByCategory = (category) =>
  affiliationPosts.filter(p => p.category === category);

export const affiliationCategories = affiliationPosts.reduce((acc, post) => {
  if (!acc.find(c => c.slug === post.category)) {
    acc.push({
      slug: post.category,
      label: post.categoryLabel,
      group: post.group,
    });
  }
  return acc;
}, []);
